import React, { useCallback } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import styled from '@emotion/styled'
import Loading from '../../components/common/Loading'
import { hepatitisDetail } from '../../constant/path'
import { useScreen } from '../../utils/responsive-helper'
import { useRouter } from '../../utils/helper'
import { useGetEClaimHistoryById } from '../../services/e-claim/e-claim-query'
import { UserClaimDocumentList, FileType, ClaimDocumentTypes } from '../../services/e-claim/e-claim-types'
import HepatitisInfo from './HepatitisInfo'
import HepatitisForm from '../HepatitisDetail/HepatitisForm'
import { useMemo } from 'react'
import dayjs from 'dayjs'
import moment from 'moment'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { setHepatitisInfo } from '../../redux-store/hepatitis-reducer'
import config from '../../config'
import colors from '../../constant/colors'

export type InitialValueType = {
  name: string
  amountReceipt: number
  amountClaim: number
  receiptFile: string
  optionalFileUrl: string
  relativeTypeId: string
  receiptDate: string
  claimName: string
}

const HepatitisHistoryDetail = () => {
  const { query } = useRouter<{ id: number }>()
  const history = useHistory()
  const dispatch = useDispatch()
  const { data: hepatitisItem, isLoading } = useGetEClaimHistoryById({ id: query.id })
  const {
    claim,
    userClaimAmount,
    userClaimAmountApprove,
    relativeId,
    slipDate,
  } = hepatitisItem || {}

  const receiptFile = useMemo(() => {
    if (!hepatitisItem?.documentTypes) return ''

    return hepatitisItem?.documentTypes?.filter(item => item.name === FileType.ReceiptFile)[0]?.files?.length > 0
      ? hepatitisItem.documentTypes.filter(item => item.name === FileType.ReceiptFile)[0].files[0].name
      : ''
  }, [hepatitisItem?.documentTypes])

  const optionalFileUrl = useMemo(() => {
    if (!hepatitisItem?.documentTypes) return ''

    return hepatitisItem?.documentTypes?.filter(item => item.name === FileType.OptionalFileUrl)[0]?.files?.length > 0
      ? hepatitisItem.documentTypes.filter(item => item.name === FileType.OptionalFileUrl)[0].files[0].name
      : ''
  }, [hepatitisItem?.documentTypes])

  const birthCertificate = useMemo(() => {
    if (!hepatitisItem?.documentTypes) return ''

    return hepatitisItem?.documentTypes?.filter(item => item.name === FileType.BirthCertificate)[0]?.files?.length > 0
      ? hepatitisItem.documentTypes.filter(item => item.name === FileType.BirthCertificate)[0].files[0].name
      : ''
  }, [hepatitisItem?.documentTypes])

  const otherDocument = useMemo(() => {
    if (!hepatitisItem?.documentTypes) return ''

    return hepatitisItem?.documentTypes?.filter(item => item.name === FileType.OtherDocument)[0]?.files?.length > 0
      ? hepatitisItem.documentTypes.filter(item => item.name === FileType.OtherDocument)[0].files[0].name
      : ''
  }, [hepatitisItem?.documentTypes])

  const initialValue = useMemo(() => {
    return {
      name: claim?.name || '',
      amountReceipt: userClaimAmount,
      amountClaim: userClaimAmountApprove,
      receiptFile,
      optionalFileUrl,
      birthCertificate,
      otherDocument,
      relativeTypeId: relativeId ? relativeId.toString() : '',
      receiptDate: slipDate,
      claimName: claim?.name || '',
    }
  }, [claim, userClaimAmount, userClaimAmountApprove, relativeId, slipDate, receiptFile, optionalFileUrl, birthCertificate, otherDocument])

  const disable = useMemo(() => {
    if (!hepatitisItem?.isApproved && (hepatitisItem?.isApproved !== null)) {
      return false
    } else {
      return true
    }
  }, [hepatitisItem?.isApproved])

  const onCreateNewHepatitis = useCallback(async () => {
    if (hepatitisItem?.id === undefined) return

    dispatch(
      setHepatitisInfo({
        name: hepatitisItem.claim.name || '',
        amountReceipt: hepatitisItem.userClaimAmount,
        amountClaim: hepatitisItem.userClaimAmountApprove,
        receiptFile,
        optionalFileUrl,
        birthCertificate,
        otherDocument,
        relativeTypeId: hepatitisItem.relativeId ? hepatitisItem.relativeId.toString() : '',
        receiptDate: hepatitisItem.slipDate,
        claimName: hepatitisItem.claim.name || '',
        receiptNo: hepatitisItem?.receiptNo || '',
      }),
    )

    history.push(hepatitisDetail({
      routeParam: {
        hepatitisId: hepatitisItem?.claimId
      },
      queryParam: {
        isCreateNew: 'true'
      }
    }))
  }, [hepatitisItem, history, dispatch, receiptFile, optionalFileUrl, birthCertificate, otherDocument])

  if (!hepatitisItem) return null

  return (
    <Loading loading={isLoading}>
      <div style={{ paddingTop: '24px' }}>
        <Headbar title={hepatitisItem?.claim.name || ''} backWard={paths.hepatitisHistory()} titleColor={colors.BLACK} />
        <HepatitisInfo id={query.id} hepatitisItem={hepatitisItem} onCreateNewHepatitis={onCreateNewHepatitis} />
        <HepatitisForm
          hepatitisItem={hepatitisItem}
          hepatitisId={hepatitisItem.claimId}
          initialValues={initialValue}
          allpayStatus={disable}
          isHistory={true}
          editable={false}
        />
      </div>
    </Loading>
  )
}

export default HepatitisHistoryDetail
